import cn from 'classnames'
import * as React from 'react'

import { ReactComponent as LogoSvg } from './dooer-logo.svg'
import { ReactComponent as LogoMiniSvg } from './dooer-logo-mini.svg'
import styles from './dooer-logo.module.scss'

interface IDooerLogoProps {
  variant?: 'standard' | 'mini' | 'circle' | 'responsive'
  theme?: 'paid' | 'free'
}

export default function DooerLogo({
  className = '',
  variant = 'standard',
  theme = 'paid',
  ...rest
}: IDooerLogoProps & React.SVGAttributes<SVGElement>) {
  const customClassName = theme === 'free' ? `${className} ${styles.free}` : className

  switch (variant) {
    case 'mini':
      return <LogoMiniSvg className={cn([styles.svg, styles.mini, customClassName])} {...rest} />

    case 'circle':
      return (
        <div className={cn([styles.circle, customClassName])}>
          <LogoSvg className={styles.circledLogo} {...rest} />
        </div>
      )

    case 'responsive':
      return (
        <div className={customClassName}>
          <LogoSvg className={cn([styles.desktop, styles.svg])} {...rest} />
          <LogoSvg className={cn([styles.mobile, styles.svg])} {...rest} />
        </div>
      )

    default:
      return <LogoSvg className={cn([styles.svg, customClassName])} {...rest} />
  }
}
